import { Button, Checkbox } from 'antd';
import React, { PureComponent } from 'react';
import { SettingsContentPanel } from '../../../common/SettingsContentPanel';
import { Flex } from '../../../common/Flex';
import { SettingFilled } from '@ant-design/icons';
import { ClosablePopover } from '../../../common/ClosablePopover';
import {
    FilterLogic,
    FLIGHT_MEASURE_FILTER_CONFIG_CLAZZ_VALUE,
    FlightMeasureFilterConfig,
} from '../../../../model/SOL49';
import { FilterSettings } from '../../../../model/client/SOL49';

export const DEFAULT_FLIGHTS_MEASURE_SETTINGS: FlightsMeasureFilterSettings = {
    filterLogic: FilterLogic.UNION,
    config: {
        clazz: FLIGHT_MEASURE_FILTER_CONFIG_CLAZZ_VALUE,
        mprOnly: false,
    },
};

export interface FlightsMeasureFilterSettings extends FilterSettings<FlightMeasureFilterConfig> {}

export class FlightsMeasureFilterSettingsContent extends SettingsContentPanel<FlightsMeasureFilterSettings> {
    handleMprOnlyChange = changeEvent => {
        const config = { ...this.state.config, mprOnly: changeEvent.target.checked };
        this.setState({ config: config });
    };
    render() {
        return (
            <Flex direction="vertical" className="settings-content" style={{ width: '30em', padding: '1em' }}>
                <Flex className="label">
                    <Checkbox
                        checked={this.state.filterLogic === FilterLogic.INTERSECT}
                        onChange={value =>
                            this.setState({
                                filterLogic: value.target.checked ? FilterLogic.INTERSECT : FilterLogic.UNION,
                            })
                        }>
                        Show only common measures concerned by selected flights
                    </Checkbox>
                </Flex>
                <Flex className="label">
                    <Checkbox checked={this.state.config?.mprOnly === true} onChange={this.handleMprOnlyChange}>
                        Show only flights being most penalised by selected measures
                    </Checkbox>
                </Flex>
                <Flex style={{ justifyContent: 'space-around' }}>
                    <Button onClick={this.handleApply}>Apply</Button>
                    <Button onClick={this.handleClose}>Close</Button>
                </Flex>
            </Flex>
        );
    }
}

interface FlightsMeasureFilterSettingsButtonProps {
    settings: FlightsMeasureFilterSettings;
    onSettingsChange: (settings: FlightsMeasureFilterSettings) => void;
}

export class FlightsMeasureFilterSettingsButton extends PureComponent<FlightsMeasureFilterSettingsButtonProps> {
    private settingsPopoverRef = React.createRef<ClosablePopover>();
    handleSettingsChange = (settings: FlightsMeasureFilterSettings) => {
        this.props.onSettingsChange?.(settings);
        this.settingsPopoverRef.current.hide();
    };
    getTvFlightsFilterSettingsContent = () => {
        return (
            <FlightsMeasureFilterSettingsContent
                settings={this.props.settings}
                onChange={this.handleSettingsChange}
                onClose={() => {
                    this.settingsPopoverRef.current.hide();
                }}
            />
        );
    };
    render() {
        return (
            <ClosablePopover
                key="settings-action"
                ref={this.settingsPopoverRef}
                trigger="click"
                placement="bottom"
                title={<div style={{ fontWeight: 'bold' }}>FILTER'S SETTINGS</div>}
                content={this.getTvFlightsFilterSettingsContent()}>
                <Button
                    onClick={() => this.settingsPopoverRef.current.show()}
                    style={{ backgroundColor: 'transparent', borderColor: 'transparent' }}>
                    <SettingFilled />
                </Button>
            </ClosablePopover>
        );
    }
}
